// @flow
import React from "react";
import styled, { css } from "styled-components";
import Label from "./Label";

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

const Input = styled.input`
  display: block;
  width: 100%;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.05);
  border: 1px solid #f5f5f5;
  outline: none;
  -webkit-appearance: none;
  line-height: 32px;
  outline: none;
  font-size: 17px;
  font-weight: ${({ theme }) => theme.typography.light};
  color: ${({ theme }) => theme.palette.navy.light};
  background-color: white;

  ${({ highContrast }) =>
    highContrast
      ? css`
          border: 1px solid #bbb;
          ::placeholder {
            opacity: 0.8;
          }
        `
      : css`
          box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.05);
          border: 1px solid #f5f5f5;
          ::placeholder {
            opacity: 0.6;
          }
        `};

  ${({ icon }) =>
    icon &&
    css`
      background-image: url('${icon}');
      background-position: top 18px right 20px;
      padding-right: 50px;
      background-size: 18px 18px;
    `};

  :disabled {
    background-color: #e9eef5;
  }
`;

type Props = {
  id?: string,
  type?: string,
  label?: string,
  icon?: string,
  name: string,
  placeholder?: string,
  value: string,
  onChange(e: SyntheticInputEvent<HTMLInputElement>): void,
  className?: string,
  "data-test"?: string,
};

export const TextInput = ({
  id,
  type = "text",
  label,
  name,
  placeholder,
  value,
  onChange,
  icon,
  className,
  "data-test": dataTest,
  ...rest
}: Props) => (
  <Wrapper data-test={dataTest} className={className}>
    {label && (
      <Label htmlFor={id} as="label">
        {label}
      </Label>
    )}
    <Input
      icon={icon}
      id={id}
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...rest}
    />
  </Wrapper>
);
